import React from 'react'
import LoginForm from '../../components/LoginForm'
import { Row, Col } from "antd";
import { useSelector } from 'react-redux';

const backgroundURL = '/img/others/img-17.jpg'
const backgroundStyle = {
	background: `radial-gradient(167.32% 164.31% at 11.2% 4.1%, #FEFFBD 0%, #B2FFE3 47.4%, #FFFFFF 100%)`,
	boxShadow: '0px 10px 25px #B4FFE3'
}

const LoginTwo = props => {
	const theme = useSelector(state => state.theme.currentTheme)

	return (
		<div className={`h-100 ${theme === 'light' ? 'bg-white' : ''}`}>
			<Row justify="center" className="align-items-stretch h-100">
				<Col xs={24} sm={24} md={12} lg={12}>
					<div className="d-flex flex-column justify-content-center align-items-center h-100 px-4" style={backgroundStyle}>
						<img src="/img/dattas-login.png" alt="logo" style={{ width: '196px' }} />
					</div>
				</Col>
				<Col xs={20} sm={20} md={12} lg={12}>
					<div className="container d-flex flex-column justify-content-center h-100 gradient-smooth">
						<Row justify="center">
							<Col xs={24} sm={24} md={20} lg={11} xl={11}>
								<h4 className="mb-4 d-block" style={{ fontWeight: 700 }}>Bem vindo(a), ao Dattas.app</h4>
								<p className="m-0 p-0">Insira seus dados para ter<br/>
								acesso ao sistema.</p>
								<div className="mt-0 new-login">
									<LoginForm {...props}/>
								</div>
							</Col>
						</Row>
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default LoginTwo
